import { PageLayout } from "#shared/layouts/PageLayout";
import { Alert } from "#shared/view/components/Alert";
import { Center } from "#shared/view/components/Center";
import { Image } from "#shared/view/components/Image";
import { Stack } from "#shared/view/components/Stack";
import { Button } from "#shared/view/designSystem/Button";

type Props = {
  onRetry: () => void;
};

export const PreviewError = ({ onRetry }: Props) => {
  return (
    <PageLayout title={`Recherche pour cette pièce`} titleIcon="shapeTriangle">
      <Stack>
        <Center>
          <Image src="/images/no-preview.png" />
        </Center>

        <Alert color="red">
          Une erreur est survenue lors du chargement de cette pièce. Il peut y avoir un problème
          avec le fichier ou le serveur. Veuillez réessayer ou contacter le support technique.
        </Alert>

        <Center>
          <Button onClick={onRetry}>Réessayer</Button>
        </Center>
      </Stack>
    </PageLayout>
  );
};
